jQuery(function($) {
	$(".wp-block-safirtema-sorucevap .question").on("click", function () {
		const group = $(this).closest(".wp-block-safirtema-safirfaqgroup");
		const parent = $(this).closest(".wp-block-safirtema-sorucevap");
		const toggle = $(this).find(".toggle");
		if(parent.hasClass("active")) {
			parent.removeClass("active").find(".answer").slideUp();
			toggle.removeClass("active");
		} else {
			group.find(".wp-block-safirtema-sorucevap, .question .toggle").removeClass("active");
			group.find(".wp-block-safirtema-sorucevap .toggl").removeClass("active");
			group.find(".wp-block-safirtema-sorucevap .answer").slideUp();
			$(this).next().slideDown();
			parent.addClass("active");
			toggle.addClass("active");
		}
	});
});